import { PageHead } from "@generalapplications/html-render/react";
import { Hero } from "@/app/pages/home/components/Hero";
import { Thesis } from "@/app/pages/home/components/Thesis";
import { Capabilities } from "@/app/pages/home/components/Capabilities";
import { Industries } from "@/app/pages/home/components/Industries";
import { Philosophy } from "@/app/pages/home/components/Philosophy";
import { ClosingBand } from "@/app/common/components/composite/layout/ClosingBand";
import { homePage } from "@/content/home";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { routes } from "@/app/common/functions/routes/routes";
import { PageArticle } from "@generalapplications/ui";

export function HomePage() {
  const head = pageHead({
    path: routes.home,
    title: homePage.seoTitle,
    description: homePage.seoDescription,
    imagePath: homePage.image,
  });

  return (
    <PageArticle rhythm="xl">
      <PageHead head={head} />
      <Hero />
      <Thesis />
      <Capabilities />
      <Industries />
      <Philosophy />
      <ClosingBand
        headline={homePage.closing.headline}
        copy={homePage.closing.copy}
        cta={homePage.closing.cta}
        ctaHref={routes.contact}
      />
    </PageArticle>
  );
}
